module.exports = __webpack_public_path__ + "assets/b31.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b31.png
// module id = 618
// module chunks = 0